// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { Account } from "../../Commons/cache/Account";
import { CustomEvent } from "../../Utils/CustomEvents";

class _AccountWidgetManager
{
    public onChangeAccount: CustomEvent = new CustomEvent();
    private account: Account;

    setAccount(acc: Account)
    {
        this.account = acc;
        this.onChangeAccount.Raise(acc);
    }

    getAccount(): Account
    {
        return this.account;
    }
}

export let AccountWidgetManager = new _AccountWidgetManager();